import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { placesService } from "services/PlacesService";
import { CountryArea } from "types";

const name: string = "action.places";
interface placesState {
  error: boolean;
  loading: Boolean;
  severity: string;
  countryCodes: CountryArea[];
}

const initialState: placesState = {
  error: false,
  loading: false,
  severity: "",
  countryCodes: [],
};
export const getContriesArea = createAsyncThunk(`${name}/getContriesArea`, async () => {
  const response = await placesService.GetCountriesAreas();
  return response;
});

export const placesSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getContriesArea.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getContriesArea.fulfilled, (state, { payload }) => {
      state.error = false;
      state.loading = false;
      state.severity = "success";
      state.countryCodes = payload;
    });
    builder.addCase(getContriesArea.rejected, (state, { payload }) => {
      state.error = true;
      state.loading = false;
      state.severity = "error";
      state.countryCodes = [];
    });
  },
});

export default placesSlice.reducer;
